import React, { Component } from 'react';
import { connect } from 'react-redux';
import Moment from 'react-moment';

class TransactionDetails extends Component {
  render() {
    return (
      <div>hi</div>
    )
  }
}

export default connect()(TransactionDetails);